import styles from './DropdownItem.module.css';

export function DropdownItem({ item, isActive, onSelect, disabled }) {
  return (
    <li
      className={`${styles.dropdown__row} ${disabled ? styles.disabled : ''} ${
        isActive && !disabled ? styles.dropdown__row_active : ''
      }`}
      onClick={disabled ? undefined : onSelect}
    >
      <div className={styles.dropdown__content}>
        <p title={item.value}>{item.label || item.value}</p>
      </div>
    </li>
  );
}
